module.exports = __webpack_public_path__ + "static/media/1018874.8cda1955.jpg";